// import { CommonModule } from '@angular/common';
// import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
// import { DxPopupModule } from 'devextreme-angular';

// @Component({
//   selector: 'app-shared-modal',
//   standalone: true,
//   imports: [CommonModule, DxPopupModule],
//   templateUrl: './shared-modal.component.html',
//   styleUrls: ['./shared-modal.component.scss']
// })
// export class SharedModalComponent {
//   @Input() popupVisible = false;
//   @Output() popupVisibleChange = new EventEmitter<boolean>();

//   @Input() title = 'Default Title';
//   @Input() width = 560;
//   @Input() height = 250;

//   @Input() hideOnOutsideClick: boolean = true;  // ✅ added
//   @Input() closeButton: boolean = true;         // ✅ added

//   @Input() contentTemplate?: TemplateRef<any>;
//   @Input() toolbarButtonOptions?: any;

//   onPopupVisibleChange(value: boolean) {
//     this.popupVisible = value;
//     this.popupVisibleChange.emit(value);
//   }

//   get mergedToolbarOptions() {
//     return {
//       ...this.toolbarButtonOptions,
//       stylingMode: 'contained',
//       elementAttr: {
//         class: 'gradient-save-btn'
//       }
//     };
//   }
// }




import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-shared-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shared-modal.component.html',
  styleUrls: ['./shared-modal.component.scss']
})
export class SharedModalComponent {
  @Input() isModalOpen = false;
  @Output() isModalOpenChange = new EventEmitter<boolean>();

  @Input() title = 'Default Title';
  @Input() contentTemplate?: TemplateRef<any>;

  closeModal() {
    this.isModalOpenChange.emit(false);
  }
}

